/// \file assetTypeRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, Route } from "react-router-dom";

const NewAssetTypeList = lazy(() => import('../views/asset-type-form/list/view'));

export async function newAssetTypeAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/asset-type-form/list/action")).action;
  return actualAction(args);
}


const routes = (
  <Route
    path="assetType"
    handle={{
      text: 'Asset Type'
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <NewAssetTypeList />
        </Suspense>
      }
      action={newAssetTypeAction}
      />
  </Route>
);

export default routes;